import ROLE from "models/role";
import { SHARED_ROUTES, UNAUTHENTICATED_ROUTES } from "definitions/constants/routeConstants";
import { Navigate } from "react-router";
import useCaminoStore from "hooks/useCaminoStore";
import React from "react";
import { intersection } from "lodash";
import { Center, Spinner } from "@chakra-ui/react";

export default function AuthenticatedRoute({
  permission,
  allowPersonalEmail = false,
  children,
}: {
  permission: ROLE[];
  allowPersonalEmail?: boolean;
  children: React.ReactNode;
}) {
  const user = useCaminoStore((state) => state.currentUser);
  const supportedRoles = useCaminoStore((state) => state.supportedRoles);
  const credentialType = useCaminoStore((state) => state.credentialType);

  if (!user) {
    return <Navigate to={UNAUTHENTICATED_ROUTES.login} />;
  }

  // null means the bundle hasn't loaded yet — hold here rather than redirecting.
  // Only redirect once we have a confirmed personal_email credential.
  if (credentialType === null) {
    return <Center py={20}><Spinner size="lg" /></Center>;
  }

  if (credentialType === "personal_email" && !allowPersonalEmail) {
    return <Navigate to={SHARED_ROUTES.home} />;
  }

  const roles = supportedRoles();
  const isAuthorized = intersection(
    permission,
    user.permission.filter((role) => roles.includes(role))
  ).length > 0;

  if (!isAuthorized) {
    console.log("AuthenticatedRoute: user does not have permission to view this page", permission, user.permission);
    return <Navigate to={SHARED_ROUTES.home} />;
  }

  return children;
}
